// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ee1deb2","453":"001da762","732":"9fb2cda5"}[chunkId] + ".chunk.js";
};